import { useSyncExternalStore } from 'react';

// THE VIEWER'S SHAPE, MOBILE OR DESKTOP (Louis 2026-11-02): Phase 6's picture, a sub-step's and the
// whole assembly's, drawn 9:16 as a phone shows it or 16:9 on a desktop, where a thin portrait box
// left most of the screen empty. Chosen in the sidebar, kept by this browser.
//
// THE SHOTS ARE THE SAME SHOTS in both: framed for 9:16 (see shotShape), and the camera keeps its
// vertical angle while the width follows the box, so the wide picture is the tall one with more room
// either side — nothing a shot keeps in view leaves it.
export type FormFactor = 'mobile' | 'desktop';

const KEY = 'notice.formFactor';
const read = (): FormFactor => {
  try {
    return localStorage.getItem(KEY) === 'desktop' ? 'desktop' : 'mobile';
  } catch {
    return 'mobile';
  }
};
let current: FormFactor = read();
const listeners = new Set<() => void>();

export function setFormFactor(next: FormFactor) {
  current = next;
  try {
    localStorage.setItem(KEY, next);
  } catch {
    // Kept for this visit only where the browser keeps nothing.
  }
  listeners.forEach((l) => l());
}

export const useFormFactor = () => useSyncExternalStore((l) => {
  listeners.add(l);
  return () => { listeners.delete(l); };
}, () => current);

// THE PICTURE'S BOX IN EACH: its height and its shape, written out whole for Tailwind.
export const SHOT_BOX: Record<FormFactor, string> = {
  mobile: 'h-[min(720px,calc(100dvh-8rem))] aspect-[9/16]',
  // THE SAME HEIGHT AS THE PHONE'S (Louis 2026-11-02): only the width grows.
  desktop: 'h-[min(720px,calc(100dvh-8rem))] aspect-video',
};
